import React from 'react';
import { Button } from './Button';

export default function PromoCard({
  title,
  description,
  buttonText,
  onButtonClick,
  className = '',
  // New optional props for richer layouts
  badge,
  note,
  secondaryButtonText,
  onSecondaryClick,
  primaryDisabled = false,
}) {
  return (
    <div className={`relative isolate overflow-hidden rounded-xl border border-accent/20 bg-gradient-to-br from-accent/8 via-background-elevated to-primary/8 p-6 h-full shadow-sm hover:shadow-md transition-all duration-200 ${className}`}>
      <div className="relative z-10">
        {badge && (
          <div className="mb-3">
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full bg-accent/10 text-accent border border-accent/20">
              {badge}
            </span>
          </div>
        )}
        <h3 className="text-foreground text-xl font-bold leading-tight mb-1">{title}</h3>
        <p className="text-sm text-muted-foreground/90 mb-4">{description}</p>

        {note && (
          <div className="text-xs text-muted-foreground/80 mb-5">
            {note}
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            variant="accent"
            size="md"
            className="w-full sm:w-auto"
            onClick={onButtonClick}
            disabled={primaryDisabled}
          >
            {buttonText}
          </Button>
          {secondaryButtonText && onSecondaryClick && (
            <Button
              variant="secondary"
              size="md"
              className="w-full sm:w-auto"
              onClick={onSecondaryClick}
            >
              {secondaryButtonText}
            </Button>
          )}
        </div>
      </div>
      <div className="pointer-events-none absolute -top-8 -right-8 h-32 w-32 rounded-full bg-accent/12 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-10 -left-10 h-36 w-36 rounded-full bg-primary/10 blur-3xl" />
    </div>
  );
}